import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { FaMapMarkerAlt, FaDirections, FaWhatsapp } from 'react-icons/fa';
import { WA_NUMBER } from '../constant/detail';

mapboxgl.accessToken =
  'pk.eyJ1Ijoic3VyeWFrdW1hcmEzMyIsImEiOiJja3k5dnBzeGIwOTVhMnZsb2RxMDRhOXNnIn0.z7pAF6oCczfW4E7_hbmD_w';

const branches = [
  {
    id: 'branch1',
    label: 'Ubud Store',
    title: 'Pool Shop Suryajaya Teknik - Ubud',
    address: 'Jalan Raya Andong, Petulu, Gianyar, Bali 80571',
    coordinates: [115.27369221532223, -8.495773472444835],
    mapLink: 'https://goo.gl/maps/yPiN7QVSgGT7akcn8',
    waText: 'Hello, Saya ingin bertanya tentang jasa perawatan kolam renang',
  },
  {
    id: 'branch2',
    label: 'Lodtunduh Store',
    title: 'Pool Shop Suryajaya Teknik - Lodtunduh',
    address: 'Jl. Raya Kengetan, Lodtunduh, Kec. Ubud, Gianyar, Bali 80571',
    coordinates: [115.26023002574675, -8.544770556862906],
    mapLink: 'https://maps.app.goo.gl/gebnMK1ijneC67Yu9',
    waText: 'Hello, Saya ingin bertanya tentang jasa perawatan kolam renang',
  },
];

const MapSection = () => {
  const mapContainers = useRef({});
  const mapInstances = useRef({});

  useEffect(() => {
    branches.forEach((branch) => {
      if (
        mapContainers.current[branch.id] &&
        !mapInstances.current[branch.id]
      ) {
        const map = new mapboxgl.Map({
          container: mapContainers.current[branch.id],
          style: 'mapbox://styles/mapbox/streets-v12',
          center: branch.coordinates,
          zoom: 14,
        });

        const marker = new mapboxgl.Marker({ color: '#ff0000' })
          .setLngLat(branch.coordinates)
          .addTo(map);

        marker.getElement().style.cursor = 'pointer';
        marker.getElement().addEventListener('click', () => {
          window.open(branch.mapLink, '_blank');
        });

        mapInstances.current[branch.id] = map;
      }
    });

    return () => {
      branches.forEach((branch) => {
        if (mapInstances.current[branch.id]) {
          mapInstances.current[branch.id].remove();
          delete mapInstances.current[branch.id];
        }
      });
    };
  }, []);

  return (
    <section id="map" className="bg-gray-50 py-14 px-4">
      {/* Section header */}
      <div className="text-center mb-10">
        <p className="text-sm font-semibold text-primary uppercase tracking-widest mb-2">
          Our Locations
        </p>
        <h2 className="text-3xl font-bold text-tertiary">Find Us in Bali</h2>
        <p className="mt-3 text-gray-500 text-sm max-w-md mx-auto">
          Visit your nearest store or contact us via WhatsApp for stock
          availability and consultation.
        </p>
      </div>

      {/* Branch cards */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {branches.map((branch) => (
          <div
            key={branch.id}
            className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100"
          >
            {/* Map */}
            <div
              className="w-full h-64"
              ref={(el) => {
                mapContainers.current[branch.id] = el;
              }}
            />

            {/* Info card */}
            <div className="p-5">
              {/* Badge + title */}
              <span className="inline-block text-xs font-semibold text-primary bg-primary/10 px-3 py-1 rounded-full mb-3">
                {branch.label}
              </span>
              <h3 className="text-base font-bold text-tertiary mb-2 leading-snug">
                {branch.title}
              </h3>

              {/* Address */}
              <div className="flex items-start gap-2 text-sm text-gray-500 mb-5">
                <FaMapMarkerAlt className="mt-0.5 flex-shrink-0 text-primary" />
                <span>{branch.address}</span>
              </div>

              {/* Action buttons */}
              <div className="flex gap-3">
                <a
                  href={branch.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 flex-1 justify-center text-sm font-semibold bg-tertiary text-white py-2.5 px-4 rounded-full hover:opacity-90 transition"
                >
                  <FaDirections />
                  Get Directions
                </a>
                <a
                  href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
                    branch.waText
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 flex-1 justify-center text-sm font-semibold border-2 border-green-500 text-green-600 py-2.5 px-4 rounded-full hover:bg-green-50 transition"
                >
                  <FaWhatsapp />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MapSection;
